import {
  getWithRedirect,
  patchWithRedirect,
  postWithRedirect
} from 'utils/axios'

import {
  TAnalysisTypeDto,
  TUpdateAnalysisTypeSettingsRequestBody
} from '@homepal/api-contract'

import { AnalysisGeneration } from 'types/AnalysisGeneration'
import { TCustomizedMetric } from 'types/GlobalMetric'

export type TAnalysisTypeResponse = TAnalysisTypeDto<TCustomizedMetric>

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/analysis-types`

export async function getAllAnalysisTypes(): Promise<{
  data: { data: TAnalysisTypeResponse[] }
}> {
  const response = await getWithRedirect<TAnalysisTypeResponse[]>(URL)

  return { data: { data: response.data.data } }
}

/** Every property in the customer's register: what can be excluded. */
export async function getAnalysisTypeRealEstates(): Promise<string[]> {
  const response = await getWithRedirect<string[]>(`${URL}/real-estates`)

  return response.data.data
}

export async function updateAnalysisTypeSettings(
  analysisTypeId: string,
  body: TUpdateAnalysisTypeSettingsRequestBody
): Promise<{ data: { data: TAnalysisTypeResponse } }> {
  return patchWithRedirect<TAnalysisTypeResponse>(
    `${URL}/${analysisTypeId}/settings`,
    {
      data: body
    }
  )
}

/*
 * Running an analysis type, and the runs that came of it. The work belongs
 * to the analyses, but what the caller operates on is the analysis type.
 */
export async function startGeneration(
  analysisTypeId: string
): Promise<AnalysisGeneration> {
  const response = await postWithRedirect<AnalysisGeneration>(
    `${URL}/${analysisTypeId}/generate`,
    {}
  )

  return response.data.data
}

export async function getGeneration(id: string): Promise<AnalysisGeneration> {
  const response = await getWithRedirect<AnalysisGeneration>(
    `${URL}/generations/${id}`
  )

  return response.data.data
}

export async function getGenerations(): Promise<AnalysisGeneration[]> {
  const response = await getWithRedirect<AnalysisGeneration[]>(
    `${URL}/generations`
  )

  return response.data.data
}

export async function cancelGeneration(
  id: string
): Promise<AnalysisGeneration> {
  const response = await postWithRedirect<AnalysisGeneration>(
    `${URL}/generations/${id}/cancel`,
    {}
  )

  return response.data.data
}
